module.exports = __webpack_public_path__ + "media/images/photos/photo-20-6bdb6de7264df72d81040682892ae344.jpg";